import { controls, grouped } from "../../controls";
import moment from "moment";

const account_balancing = {
  label: "Account Balancing",
  starting: true,
  url: "recipt_payment",
  pageLabel: "Account Balancing",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branches" }),
    ...controls.oc({ tab: "filter", c: "Branches", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-1" }),
    
    ...controls.displayText({ tab: "general", width: "col-sm-1", label: "Account" }),
    ...controls.oc({ tab: "general", width: "col-sm-2", c: "Account", placeHolder: "Account Number", name: "account_code", fastpath: "accounts" }),
    ...controls.showData({ tab: "general", width: "col-sm-2", displaytype: "capital", data: "account_display" }),
     

    ...controls.magicDateLabel({ label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name: "from_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),
    
    ...controls.magicDateLabel({ label:"To Date", width:"col-sm-2", target:"to_date" }),
    ...controls.magicDate({ dateType: "ontype", isRequired: true, name:"to_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),



  ],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Account Balancing",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    extraRows: {
      location: "top",
      fields: ["disbursement", "recovery", "outstanding"],
      grandtotal: { type: "fixed", displayIn: "customer_name", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
      },
      {
        Header: "customer id",
        accessor: "customer_id",
        width: "*"
      },
      {
        Header: "Name",
        accessor: "customer_name",
        width: "*"
      },
      {
        Header: "Account Number",
        accessor: "account_code",
        
      },
     
     
      {
        Header: "Outstanding",
        accessor: "outstanding",
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'disbursement', mult: { source: "fixed", val: -1, field: 'mult', fixed: { mult: -1 } } }, { source: 'row', field: 'recovery' }
          ], resultVar: 'total'
        }],
        type: "currency",
        // back: (d) => currencyToNumber(d['debit_total']) == currencyToNumber(d['credit_total']) ? "orange" : "white",
      },
     
    ]
  }
};

export default account_balancing;